import { APIBase } from "nate-react-api-helpers";
import { Account } from "./Account";
import { Admin } from "./Admin";
import { ApiTokens } from "./ApiTokens";
import { Feed } from "./Feed";
import { Files } from "./Files";
import { Projects } from "./Projects";
import { Tasks } from "./Tasks";
import { Teams } from "./Teams";
import { Users } from "./Users";

class API extends APIBase {
    account = new Account(this);
    admin = new Admin(this);
    apiTokens = new ApiTokens(this);
    feed = new Feed(this);
    files = new Files(this);
    projects = new Projects(this);
    tasks = new Tasks(this);
    teams = new Teams(this);
    users = new Users(this);

    constructor() {
        super({
            jwtRefreshEndpoint: "/api/auth/refresh",
        });
    }
}

export const api = new API();
